import { UseFormReturn } from "react-hook-form";
import { useGlobalData } from "../GlobalDataProvider";
import SelectEditor from "../Global/Editors/SelectEditor";
import { DTOModule } from "../../types/building";
import StaticBox from "../Global/StaticBox";
import { IModuleVärmeElConfig } from "../../types/ModuleDatas";
import { nameof } from "../Global/Utils";
import { MapTooltip } from "../../types/globalData";
import { logDebugSilently } from "../../modules/logger";

interface IProps {
  module: DTOModule;
  data: any;
  formHook: UseFormReturn;
}

const ConfigDirektverkandeEL = ({ module, data, formHook }: IProps) => {
  const globalData = useGlobalData();

  const varmeStyrningList = globalData.data ? globalData.data.Värme.DirektElStyrning.map((r) => r.DirektElStyrning) : [];
  varmeStyrningList.splice(0, 0, "");
  const mt = globalData.moduleTypes.find((mt) => mt.id === module.moduleTypeId);
  const mtDisplayName = mt ? mt.displayName : "";

  logDebugSilently("Render : ConfigDirektverkandeEL");

  return (
    <>
      <div className="row ml-0">
        <div className="col-lg-12">
          <StaticBox label="Värmeavgivare" text={mtDisplayName}></StaticBox>
        </div>
        <div className="col-lg-12">
          <StaticBox label="Systemandel (%)" text={data[nameof<IModuleVärmeElConfig>("värmeSystemandel")]} tooltipId={nameof<MapTooltip>("VärmeEl_värmeSystemandel")}></StaticBox>
        </div>
        <div className="col-lg-12">
          <StaticBox label="Betjäningsområde" text={data[nameof<IModuleVärmeElConfig>("betjäningsområde")]} tooltipId={nameof<MapTooltip>("VärmeEl_betjäningsområde")}></StaticBox>
        </div>
        <div className="col-lg-12">
          <SelectEditor
            label="Ange typ av värmestyrning"
            formHook={formHook}
            fieldName={nameof<IModuleVärmeElConfig>("värmeStyrning")}
            tooltipId={nameof<MapTooltip>("VärmeEl_värmeStyrning")}
            items={varmeStyrningList}
            options={{
              validate: {
                required: (v) => {
                  return !v ? "Ange värmestyrning" : undefined;
                },
              },
            }}
          ></SelectEditor>
        </div>
        <div className="col-lg-12">
          <SelectEditor
            label="Funktion för överordnat värmestopp"
            formHook={formHook}
            fieldName={nameof<IModuleVärmeElConfig>("harÖverordnatVärmestopp")}
            tooltipId={nameof<MapTooltip>("VärmeEl_harÖverordnatVärmestopp")}
            items={["Nej", "Ja"]}
          ></SelectEditor>
        </div>
      </div>
    </>
  );
};

export default ConfigDirektverkandeEL;
